<template>
  <el-row :gutter="20">
    <el-col :span="20" :offset="2">
      <div class="message_content_layout">
        <el-row class="el-row-content">
          <el-col class="el-row-content-text el-row-child" :span="6">
            <div class="item">当前余额</div>
            <img class="el-row-img item" src="../../../assets/images/u2850.png" alt />
            <div class="content-text item" >￥{{list_data.current_balance}}</div>
            <el-button size="mini" class="row-button" @click="apply_money()">申请提现</el-button>
          </el-col>
          <el-col class="el-row-content-text" :span="6">
            <div class="item-span">累计获得</div>
            <div class="content-text" >￥{{list_data.grand_total}}</div>
          </el-col>
          <el-col class="el-row-content-text" :span="6">
            <div class="item-span">被支付单数</div>
            <div class="content-text" >{{list_data.order_total}}</div>
          </el-col>
          <el-col class="el-row-content-text" :span="6">
            <div class="item-span">累计提现</div>
            <div class="content-text">￥{{list_data.cash_out}}</div>
          </el-col>
        </el-row>
        <div>
          <div class="wallet_content">
            <el-card shadow="hover">
              <div slot="header" class="clearfix">
                <span>近期明细</span>
              </div>
              <!--判断为空-->
              <div class="emtyData-center" v-if="record_list ==''">
                <emptyData></emptyData>
              </div>
              <div v-else>
                <div class="msg_warpper" v-for="item in record_list" :key="item.index">
                  <div class="msg_content">
                    <div class="msg">
                      <span class="msg_title">
                        <span class="message msg_item" v-text="item.title"></span>
                      </span>
                    </div>
                    <span class="msg_time">
                      <span class="create_time">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <span v-text="item.created"></span>
                      </span>
                    </span>
                  </div>
                  <span class="unread_red-text">{{item.money_text}}</span>
                </div>
              </div>
            </el-card>
            <!--分页区-->
            <el-row v-if="record_list !=''" :gutter="20">
              <el-col :span="6" :offset="10">
                <el-pagination
                  @current-change="currentPageChange"
                  :page-size="pageList.pageSize"
                  :current-page="pageList.pageNum"
                  layout="total, prev, pager, next"
                  :total="pageList.total"
                ></el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import emptyData from "@/components/common/emptyData";
import util from "@/utils";
import { getWallet, getWalletList } from "@/api/index.js";
export default {
  data() {
    return {
      list_data: "",
      record_list: [],
      pageList: {},
      status: "",
      page: 5,
      pageNum: 1
    };
  },
  components: {
    emptyData: emptyData
  },
  created() {
    const that = this;
    that.readyList();
    that.recordList();
  },
  methods: {
    handleClick(tab, event) {
      const that = this;
      console.log("that.status", that.status);
      // that.page = 1;
      // that.readyList();
    },
    currentPageChange(val) {
      console.log("val", val);
      var that = this;
      that.pageNum = val;
      that.recordList();
    },
    /**
     * 申请提现
     */
    apply_money() {
      this.$router.push({
        path: "/index/user/wallet/addCash"
      });
    },

    /**
     * 初次获取数据
     */
    readyList() {
      const that = this;
      const params = {
        token: util.getStore("user_token")
      };
      getWallet(params).then(that.readyHandle);
    },
    readyHandle(res) {
      const that = this;
      that.list_data = res.data;
    },
    /**
     * 获取收入明细记录
     */
    recordList() {
      const that = this;
      const params = {
        token: util.getStore("user_token"),
        pageNum: that.pageNum,
        pageSize: that.page
      };
      getWalletList(params).then(that.recordHandle);
    },
    recordHandle(res) {
      const that = this;
      if (res.code === 1) {
        const result = res;
        that.record_list = result.data.data;
        that.pageList = result.data;
      } else {
        that.$message({
          showClose: true,
          message: res.msg,
          type: "error"
        });
      }
    },
    isread(status) {
      if (status) {
        return true;
      } else {
        return false;
      }
    },
    callBackHandle(res) {
      const that = this;
      const result = res.data;
      if (result.code === 0) {
        that.$message({
          showClose: true,
          message: result.msg,
          type: "success"
        });
      } else {
        that.$message({
          showClose: true,
          message: result.msg,
          type: "error"
        });
      }
    }
  },
  mounted() {
    this.readyList();
  }
};
</script>
<style>
.wallet_content .el-card {
  margin-top: 10px;
  font-size: 14px;
  min-height: 4em;
  /* position: relative; */
}

.wallet_content .create_time {
  font-size: 11px;
  color: #999;
}

.wallet_content {
  line-height: 1.25rem;
  position: relative;
}

.wallet_content .unread_red-text {
  display: block;
  position: absolute;
  top: 20px;
  right: 50px;
  color: red;
  font-weight: 700;
}
.wallet_content .msg_warpper {
  position: relative;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
}
.wallet_content .msg_warpper .msg_title {
  font-size: 16px;
  font-weight: bold;
  color: #f39c12;
}

.el-row-content {
  height: 180px !important;
  border: 1px #dbdbdb solid;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.el-row-child {
  border-right: 1px #dbdbdb solid;
}

.content-text {
  color: #00afff;
  font-weight: 700;
}

.el-row-content-text {
  text-align: center;
}

.message_content_layout .el-button {
  background-image: url("../../../assets/images/rectangle6.png");
}

.message_content_layout .item {
  margin-bottom: 15px;
}

.message_content_layout .el-row-img {
  width: 50px;
}

.message_content_layout .item-span {
  margin-bottom: 30px;
}
/**
	*把user中样式覆盖
	*/
.message_content_layout .el-card__body {
  padding: 0 !important;
}
</style>
